import React from "react";
import constants from "./constants";
import { PrivateRoutes } from "../../Components/PrivateRoutes";

const HomeRouter = () => {
  return <PrivateRoutes routeConfig={constants.HOME_ROUTER_ROUTES} />;
};

export default HomeRouter;
